import { Label } from 'components/ui/label';
import { Switch } from 'components/ui/switch';
import { ColorPicker } from 'components/Inputs/ColorPicker';
import { ListBoxInput } from 'components/Inputs/ListBoxInput';
import { Slider } from 'components/Inputs/Slider';
import { LineCurve } from 'eazychart-core';
import { useChartConfig } from 'hooks/useChartConfig';

const curve: { [key in LineCurve]: string } = {
  curveLinear: 'Linear',
  curveBasis: 'Basis',
  curveBumpX: 'BumpX',
  curveBumpY: 'BumpY',
  curveBundle: 'Bundle',
  curveCardinal: 'Cardinal',
  curveNatural: 'Natural',
  curveStep: 'Step',
  curveStepAfter: 'Step After',
  curveStepBefore: 'Step Before',
};

export const AreaForm = () => {
  const {
    chart: {
      props: { swapAxis, marker, area },
    },
    updateChartProps,
  } = useChartConfig();

  const curveOptions = Object.entries(curve).map(([value, label]) => ({
    value,
    label,
  })) as Array<{ value: LineCurve; label: string }>;
  return (
    <div>
      <form className="flex flex-col gap-2">
        <div className="my-2">
          <h3 className="mb-2">Inverser les axes</h3>
          <div className="flex items-center space-x-2">
            <Switch
              id="area-swap-axis-toggle"
              checked={swapAxis}
              onCheckedChange={(isEnabled) =>
                updateChartProps({ swapAxis: isEnabled })
              }
            />
            <Label htmlFor="area-swap-axis-toggle" className="cursor-pointer">
              Inverser les axes
            </Label>
          </div>
        </div>
        <div className="my-2">
          <h3 className="mb-2">Style du marqueur</h3>
          <div>
            <div className="flex items-center space-x-2">
              <Switch
                id="area-marker-hidden-toggle"
                checked={Boolean(marker?.hidden)}
                onCheckedChange={(isEnabled) =>
                  updateChartProps({
                    marker: { ...(marker ?? {}), hidden: isEnabled },
                  })
                }
              />
              <Label
                htmlFor="area-marker-hidden-toggle"
                className="cursor-pointer"
              >
                Masqué
              </Label>
            </div>
          </div>
          <div className="my-2">
            <ColorPicker
              defaultColor={'#000000'}
              onChange={(color: string) =>
                updateChartProps({ marker: { ...marker, color } })
              }
            />
          </div>
          <div>
            <Slider
              defaultValue={0}
              onChange={(slider) =>
                updateChartProps({ marker: { ...marker, radius: slider } })
              }
            />
          </div>
          <hr />
          <h3 className="mb-2">Couleur</h3>
          <div className="my-2">
            <ColorPicker
              defaultColor={area.fill}
              onChange={(fill: string) =>
                updateChartProps({ area: { ...area, fill } })
              }
            />
          </div>
          <hr />
          <div className="my-2">
            <h3 className="mb-2">Style de ligne</h3>
            <div>
              <div>
                <ListBoxInput<LineCurve>
                  defaultValue={area.curve}
                  options={curveOptions}
                  onChange={(curve: LineCurve) => {
                    updateChartProps({
                      area: { ...area, curve },
                    });
                  }}
                />
              </div>
              <div className="my-2">
                <ColorPicker
                  defaultColor={area.stroke}
                  onChange={(stroke) =>
                    updateChartProps({ area: { ...area, stroke } })
                  }
                />
              </div>
              <div>
                <Slider
                  defaultValue={0}
                  onChange={(strokeWidth) =>
                    updateChartProps({ area: { ...area, strokeWidth } })
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
